import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { api_route, user_logout } from '../helpers/Global';

class Header extends React.Component {

    constructor() {
        super();
        this.state = {
            user_dropdown: '',
            search_form: false,
            notifications: [],
            color_notif_icon: '#BBB',
            current_page: ''
        }
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        this.props.loaderDisplay(false);
        this.getNotifications();
        // setInterval(
        //     function () {
        //         this.getNotifications();
        //     }.bind(this), 60000
        // );
    }
    componentDidUpdate() {
        if (this.state.current_page !== this.props.current_page) {
            this.setState({ current_page: this.props.current_page })
        }
    }

    getNotifications = () => {
        fetch(api_route('alerts'), { method: 'GET' })
            .then(resp => resp.json())
            .then(resp => {
                if (resp.response === 'error-connected') {
                    user_logout();
                    this.props.history.push(`/user-logout`);
                } else if (resp['liste-alerts']) {
                    this.setState({
                        notifications: resp['liste-alerts'],
                        color_notif_icon: (resp['liste-alerts'].length ? '#fece04' : '#BBB')
                    }, function () {
                        if (resp['info-general'] && typeof this.props.setLivreur === 'function') {
                            this.props.setLivreur(resp['info-general']);
                        }
                        if (typeof this.props.setNotifications === 'function') {
                            this.props.setNotifications(this.state.notifications);
                        }
                    });
                }
            })
            .catch(err => {
                this.props.loaderDisplay(false);
                this.props.openErrorSystem(true);
            })
    }

    render() {
        const livreur = this.props.livreur;

        var show_menu = (this.state.current_page === 'replymessage' || this.state.current_page.includes("replymessagecolis") ||
            this.state.current_page === 'facture_journal' || this.state.current_page === 'action_coli' || this.state.current_page === 'echec_coli_motif' || this.state.current_page === 'call_coli' || this.state.current_page === 'coli_journal') ? false : true;
        
        var page_listing = "";
        if(this.state.current_page === 'echec_coli_motif'){
            page_listing = "action_coli";
        }else{
            page_listing = "list_colis";
        } 
        
        if(this.state.current_page === 'facture_journal'){
            page_listing = "list_factures";
        }
        
        if(this.state.current_page === 'replymessage'){
            page_listing = "liste_messages";
        }
        
        if(this.state.current_page.includes("replymessagecolis")){
            page_listing = this.state.current_page;
        }
        
        if (this.state.current_page === 'call_coli') {
            return (<React.Fragment></React.Fragment>);
        }
                    
        return (
            <React.Fragment>
                <header className="header">
                    <nav className="container-fluid">
                        <div className="row">
                            <div className="col-auto align-self-center">
                                <div className="row h-100">
                                    <div className="col-auto">
                                        {show_menu ? (
                                            <button className="btn btn-sm btn-link menu-btn" type="button" onClick={() => this.props.openSidebar()}>
                                                <i className="material-icons">menu</i>
                                            </button>
                                        ) : (
                                                <button className="btn btn-sm btn-link menu-btn" type="button" onClick={() => this.RedirectPage(page_listing)}>
                                                    <i className="material-icons">arrow_back</i>
                                                </button>

                                            )}
                                    </div>
                                    <div className="col self-align-center"></div>
                                </div>
                            </div>
                            <div className="col text-center align-self-center px-0"></div>
                            <div className={`col-auto text-right align-self-center`}>
                                <form onSubmit={this.handleSearch} className={`form-inline search-form animated faster${this.state.search_form ? ' d-block fadeInDown' : ' fadeOutUp'}`}>
                                    <input className="form-control border-0" type="text" placeholder="Recherche" onChange={this.changeInputSearch} />
                                    <button className="btn btn-sm btn-link template-primary" type="button" onClick={() => this.openSearchForm(false)}>
                                        <i className="material-icons">close</i>
                                    </button>
                                </form>
                                <button className="btn btn-sm btn-link template-primary search-button" type="button" onClick={() => this.openSearchForm(true)}>
                                    <i className="material-icons">search</i>
                                </button>
                                <button onClick={() => this.refreshPage()} className="btn btn-link dropdown-toggle no-caret">
                                    <i className="material-icons">refresh</i>
                                </button>
                                <button className="btn btn-link dropdown-toggle no-caret" type="button" onClick={() => this.openNotificationModal(true)} style={{ color: this.state.color_notif_icon }}>
                                    <i className="material-icons">notifications</i>
                                </button>
                                <div className="btn-group">
                                    <div className={`dropdown ${this.state.user_dropdown}`}>
                                        <button className="btn btn-sm btn-link dropdown-toggle no-caret user-profile" type="button" onClick={() => this.openDropdownUser()}>
                                            <span className="avatar avatar-25"><img src={livreur.livreur_photo_small} alt="user" /></span>
                                        </button>
                                        <div className={`dropdown-menu dropdown-menu-right w-100 ${this.state.user_dropdown}`}>
                                            <Link to="/password" className="dropdown-item" onClick={() => this.openDropdownUser()}>Modifier le mot de passe</Link>
                                            <Link to="/user-logout" className="dropdown-item text-danger" onClick={() => this.openDropdownUser()}>Déconnexion <i className="material-icons icon-right icon">exit_to_app</i></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </header>

            </React.Fragment>
        );
    }

    handleSearch(event) {
        event.preventDefault();
        this.props.history.push(`/colis/list?keyword=` + this.state.keyword + '&t=' + Date.now());
        this.setState({ search_form: false });
    }

    changeInputSearch = (event) => {
        this.setState({ keyword: event.target.value })
    }

    openDropdownUser = () => {
        const user_dropdown = this.state.user_dropdown === 'show' ? '' : 'show';
        this.setState({ user_dropdown: user_dropdown });
    }

    openNotificationModal = (v) => {
        this.props.showModal('notification');
    }

    refreshPage = () => {
        if (window.isNativeApp) {
            return window.ReactNativeWebView.postMessage('page-refresh');
        } else {
            window.location.reload();
        }
    }

    openSearchForm = (v) => {
        this.setState({ search_form: v });
    }

    RedirectPage = (v) => {
        
        if(v == "liste_messages"){
            this.props.setCurrentPage("liste_messages");
            this.props.history.push("/messages?t="+ Date.now());
        
        }else if(v.includes("replymessagecolis")){
            var number_colis = v.replace('replymessagecolis-','');
            this.props.setCurrentPage("colis");
            this.props.history.push('/colis/list?fixedkeyword='+number_colis+'&t=' + Date.now());
        
        }else{
            this.props.setCurrentPage(v);
        }
    }


}

export default withRouter(Header);